import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const deviceId = localStorage.getItem("device_id");
  if (deviceId) {
    config.headers["X-Device-ID"] = deviceId;
  }
  return config;
});

export default api;